module.exports = __webpack_public_path__ + "img/navbar-cart.e63a844e.svg";